import React from 'react';
import { StarIcon } from 'lucide-react';
export function Sidebar() {
  const ratingBreakdown = [{
    stars: 5,
    percentage: 90,
    color: 'bg-yellow-400'
  }, {
    stars: 4,
    percentage: 7,
    color: 'bg-yellow-400'
  }, {
    stars: 3,
    percentage: 2,
    color: 'bg-yellow-400'
  }, {
    stars: 2,
    percentage: 0,
    color: 'bg-gray-300'
  }, {
    stars: 1,
    percentage: 1,
    color: 'bg-gray-300'
  }];
  const featureRatings = [{
    name: 'Price',
    rating: 5.0
  }, {
    name: 'Effectiveness',
    rating: 5.0
  }, {
    name: 'Comfort',
    rating: 5.0
  }];
  return <div className="space-y-6" data-id="element-412">
      {/* Product Card */}
      <div className="bg-white border border-gray-200 rounded-lg p-6 sticky top-4" data-id="element-413">
        <h3 className="text-xl font-bold text-center mb-4" data-id="element-414">Recommended</h3>

        <div className="flex justify-center mb-6" data-id="element-415">
          <img src="https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=300&h=300&fit=crop" alt="Cotevich" className="w-48 h-48 object-contain" data-id="element-416" />
        </div>

        <a href="https://cotevich.com/products/pestrepeller" target="_blank" rel="noopener noreferrer" className="block w-full bg-green-600 hover:bg-green-700 text-white font-bold py-4 px-6 rounded-lg text-center transition-colors text-lg mb-6" data-id="element-417">
          GET 40% OFF Cotevich NOW!
        </a>

        {/* Customer Reviews */}
        <div className="border-t pt-6" data-id="element-418">
          <h4 className="font-bold text-lg mb-4" data-id="element-419">Customer Reviews</h4>

          <div className="flex items-center gap-2 mb-2" data-id="element-420">
            <div className="flex" data-id="element-421">
              {[...Array(5)].map((_, i) => <StarIcon key={i} size={20} className="fill-yellow-400 text-yellow-400" data-id="element-422" />)}
            </div>
            <span className="font-bold text-lg" data-id="element-423">4.3 out of 5</span>
          </div>

          <p className="text-gray-500 text-sm mb-4" data-id="element-424">4,354 customer ratings</p>

          {/* Rating Breakdown */}
          <div className="space-y-2 mb-6" data-id="element-425">
            {ratingBreakdown.map(item => <div key={item.stars} className="flex items-center gap-2 text-sm" data-id="element-426">
                <span className="w-12 text-green-600 font-medium" data-id="element-427">
                  {item.stars} Star
                </span>
                <div className="flex-1 bg-gray-200 rounded-full h-4 overflow-hidden" data-id="element-428">
                  <div className={`h-full ${item.color}`} style={{
                width: `${item.percentage}%`
              }} data-id="element-429" />
                </div>
                <span className="w-12 text-right text-green-600 font-medium" data-id="element-430">
                  {item.percentage}%
                </span>
              </div>)}
          </div>

          {/* By Feature */}
          <div className="border-t pt-4" data-id="element-431">
            <h5 className="font-bold mb-3" data-id="element-432">By Feature</h5>
            <div className="space-y-2" data-id="element-433">
              {featureRatings.map(feature => <div key={feature.name} className="flex items-center justify-between" data-id="element-434">
                  <span className="text-sm text-gray-700" data-id="element-435">{feature.name}</span>
                  <div className="flex items-center gap-1" data-id="element-436">
                    <div className="flex" data-id="element-437">
                      {[...Array(5)].map((_, i) => <StarIcon key={i} size={14} className="fill-yellow-400 text-yellow-400" data-id="element-438" />)}
                    </div>
                    <span className="text-sm font-medium ml-1" data-id="element-439">
                      {feature.rating}
                    </span>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </div>;
}